export const locale = {
  lang: 'en',
  data: {
    'EMAIL_HISTORY': {

    },

  }
};
